// 医院二级域名定制网页配置参数


const eduWebConfig = {
  namespaced: true,
  state: {
    hospitalWebConfigInfo: null, // 当前教育局信息
    hospitalList: [{
        id: 1, // 配置编号
        hospitalName: '心海蓝韵', // 医院名称
        isShowWebName:true,
        webName: '心理健康管理服务云平台', // 平台名称
        realmName: 'https://www.lanyunxinli.com' // 域名地址
      },
      {
        id: 2, // 配置编号
        hospitalName: '双流区黄甲社区卫生服务中心心理WCT', // 医院名称
        isShowWebName:false,
        webName: '双流区黄甲社区卫生服务中心心理WCT', // 平台名称
        realmName: 'http://hjsq.lanyunxinli.com' // 域名地址
      },
    ]
  },
  mutations: {
    // 通过域名地址获取教育局配置信息
    getEduWebConfigInfo(state) {
      let currentHref = window.location.href.split('lanyunxinli.com'); // 获取当前网页地址
      if (currentHref[0].indexOf('http://localhost') == -1) {
        currentHref = currentHref[0] + 'lanyunxinli.com'; // 获取当前域名
      } else {
        currentHref = "https://www.lanyunxinli.com"
      }
      let currentHospital = state.hospitalList.find(e => e.realmName == currentHref); // 通过域名获取
      if (currentHospital) {
        document.title = currentHospital.hospitalName +'-'+ currentHospital.webName;
        state.hospitalWebConfigInfo = currentHospital;
      }
    },

  },
}

export default eduWebConfig



// WEBPACK FOOTER //
// ./src/vuex/eduwebconfig.js